module.exports = __webpack_public_path__ + "img/wzzj1-1.b3426add.jpg";